import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index.vue'
import signUp from '@/pages/sign-up/index.vue'
import login from '@/pages/login'
import passStatus from '@/pages/pass-status/'
import editCoveralls from '@/pages/edit-coveralls/'
import msgAudit from '@/pages/msg-audit/'
import defeat from '@/pages/defeat/'
import appointedRoadTest from '@/pages/appointed-road-test'
import withoutPage from '@/pages/without-page'
import recruitAnswer from '@/pages/recruit-answer/index.vue'
import cardIDUpLoad from '@/pages/carID-uploading/index.vue'
import licenceLoad from '@/pages/driving-licence-uploading/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/index',
      name: 'Index',
      component: Index
    },
    {
      path: '/sign-up/:status',
      name: 'signUp',
      component: signUp
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/pass-status/:status',
      name: 'passStatus',
      component: passStatus
    },
    {
      path: '/edit-coveralls/:status',
      name: 'editCoveralls',
      component: editCoveralls
    },
    {
      path: '/msg-audit/:status',
      name: 'msgAudit',
      component: msgAudit
    },
    {
      path: '/defeat',
      name: 'defeat',
      component: defeat
    },
    {
      path: '/recruit-answer/:status',
      name: 'recruitAnswer',
      component: recruitAnswer
    },
    {
      path: '/appointed-road-test/:status',
      name: 'appointedRoadTest',
      component: appointedRoadTest
    },
    {
      path: '/without-page',
      name: 'withoutPage',
      component: withoutPage
    },
    {
      path: '/carID-uploading/:status',
      name: 'cardIDUpLoad',
      component: cardIDUpLoad
    },
    {
      path: '/driving-licence-uploading/:status',
      name: 'licenceLoad',
      component: licenceLoad
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js